export const readableFileSize = (bytesSize: number) => {
  if (bytesSize < 1024) {
    return `${bytesSize} bytes`;
  }
  if (bytesSize < 1024 ** 2) {
    return `${Math.round(bytesSize / 1024)}KB`;
  }
  if (bytesSize < 1024 ** 3) {
    return `${Math.round(bytesSize / 1024 ** 2)}MB`;
  }
  return `${Math.round(bytesSize / 1024 ** 3)}GB`;
};
